import React from 'react';
import { useEffect, useState } from 'react';

interface RemoteConfigFields {
  [key: string]: string | number | boolean;
}

interface FetchNotificationConnectorRemoteConfigProps {
  children: (props: {
    loading: boolean;
    notificationData: RemoteConfigFields | null;
  }) => React.ReactElement;
  fetchRemoteConfigFields: (fields: string[]) => Promise<RemoteConfigFields>;
  remoteConfigFields: string[];
  remoteConfigLanguageCode?: string;
}

const FetchNotificationConnectorRemoteConfig = ({
  children,
  fetchRemoteConfigFields,
  remoteConfigFields,
  remoteConfigLanguageCode,
}: FetchNotificationConnectorRemoteConfigProps) => {
  const [loading, setLoading] = useState(true);
  const [configValues, setConfigValues] = useState<RemoteConfigFields | null>(null);

  useEffect(() => {
    const getRemoteConfigValues = async () => {
      let remoteConfigFieldsWithLanguageCode = remoteConfigFields;

      if (remoteConfigLanguageCode) {
        remoteConfigFieldsWithLanguageCode = remoteConfigFields.map(
          (field) => `${remoteConfigLanguageCode}_${field}`
        );
      }

      try {
        const values = await fetchRemoteConfigFields(remoteConfigFieldsWithLanguageCode);

        const valuesWithoutLanguageCode = Object.keys(values).reduce((acc, key) => {
          const newKey = key.replace(/^[a-z]{2}_/, '');
          acc[newKey] = values[key];
          return acc;
        }, {} as RemoteConfigFields);

        if (remoteConfigLanguageCode) {
          setConfigValues(valuesWithoutLanguageCode);
        } else {
          setConfigValues(values);
        }
      } catch (err) {
        console.error('Failed to fetch config values:', err);
      } finally {
        setLoading(false);
      }
    };
    getRemoteConfigValues();
  }, [fetchRemoteConfigFields, remoteConfigFields]);

  return children({ loading, notificationData: configValues });
};

export default FetchNotificationConnectorRemoteConfig;
